import { StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { CircularIconContainer } from "../CircularIconContainer";

type Props = {
	title: string;
	iconName?: IconType;
};

export const LeaderboardCardHeader = ({
	title,
	iconName = "trophy-outline",
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			gap={12}
			padding={16}
			borderBottomWidth={1}
			borderBottomColor={theme.colors.surfaceVariant}
		>
			<CircularIconContainer
				iconName={iconName}
				size={40}
				iconSize={24}
				backgroundColor={theme.colors.secondaryContainer}
				iconColor={theme.colors.onSecondaryContainer}
			/>
			<Text
				numberOfLines={1}
				variant="titleSmall"
				style={[styles.title, { color: theme.colors.onSurface }]}
			>
				{title}
			</Text>
		</Box>
	);
};

const styles = StyleSheet.create({
	title: {
		flex: 1,
		flexShrink: 1,
		fontWeight: "600",
	},
});
